import styled from '@emotion/styled';
import {mixinOverflow, mixinSubHeading} from 'webapp-lib/styling';

export const DialogContentActions = styled.div<{stepperActions?: boolean}>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  // Following the same properties as Actions for the time where both are used
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: var(--gutter);
  padding: var(--gutter);
  ${({stepperActions}) =>
    stepperActions
      ? `justify-content: space-between;
      border-top: var(--regular-border-width) solid var(--color-core-primary);`
      : ''}
`;

export const RightSide = styled.div`
  display: inline-flex;
  gap: var(--gutter);
`;

export const Actions = styled.div<{stepperActions?: boolean}>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: var(--gutter);
  padding: var(--gutter);
  ${({stepperActions}) =>
    stepperActions
      ? `justify-content: space-between;
      border-top: var(--regular-border-width) solid var(--color-core-primary);`
      : ''}
`;

export const InFormActions = styled(Actions)`
  padding: 0;
  margin-top: var(--gutter);
`;

export const DialogWrapper = styled.div<{hasActions?: boolean}>`
  position: relative; // ensure that you can use position:absolute within the dialog
  display: flex;
  border: none;
  border-radius: var(--border-radius);
  min-width: var(--dialog-tiny-width);
  max-height: max(80vh, calc(var(--application-height-min) * 0.8));
  flex-direction: column;
  background-color: var(--color-core-white);
  padding: var(--gutter);
  ${({hasActions}) => (hasActions ? 'padding-bottom: 0px;' : '')}
  word-break: break-word;

  ${mixinOverflow}
  &.tiny {
    width: var(--dialog-tiny-width);
  }

  &.little {
    width: var(--dialog-little-width);
  }

  &.small {
    width: var(--dialog-small-width);
  }

  &.medium {
    width: var(--dialog-medium-width);
  }

  &.large {
    width: var(--dialog-large-width);
  }

  &.huge {
    width: var(--dialog-huge-width);
  }
`;

export const DialogHeading = styled.h2`
  ${mixinSubHeading}
  margin-bottom: var(--gutter);

  // styling for the close button
  margin-right: var(--gutter-big);
`;

export const Description = styled.section`
  font-size: var(--font-size-default);
  color: var(--color-core-black);
  font-weight: var(--font-weight-thin);
  margin: var(--gutter-little) 0;
  white-space: pre-line;
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: var(--gutter-little);
  right: var(--gutter-little);
`;
